import {
    AGREGAR_TEACHER,
    OBTENER_TEACHER,
    LISTA_TEACHERS,
    MATCH_TEACHER,
    ERROR_TEACHER
} from "../../types";

const TeacherReducer = (state, action) => {
    switch (action.type) {
        case AGREGAR_TEACHER:
            return {
                ...state,
                teacher: action.payload,
                errorResult: false
            }
        case OBTENER_TEACHER:
            return {
                ...state,
                teacher: action.payload
            }
        case ERROR_TEACHER:
            return {
                ...state,
                teacher: null,
                errorResult: true,
                msg: action.payload
            }
        case LISTA_TEACHERS:
            return {
                ...state,
                teacher: null,
                allTeachers: action.payload
            }
        case MATCH_TEACHER:
            return {
                ...state,
                studentsFromTeacher: action.payload
            }
        default:
            return state;
    }
}

export default TeacherReducer;